var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M21 88c0-27 22-49 49-49h391c27 0 48 22 48 49s-22 49-48 49H70c-27 0-49-22-49-49zm0 176c0-27 22-48 49-48h391c27 0 48 21 48 48s-22 49-48 49H70c-27 0-49-21-49-49zm0 177c0-27 22-49 49-49h286c26 0 48 21 48 49 0 26-21 48-48 48H70c-27 0-49-21-49-48z" })
  );
});